/**
 * Live Chat State - Default Implementation
 *
 * Provides the default implementation of ILiveChatState.
 * Uses Signal.State for reactive state management.
 */

import { Signal } from "@lit-labs/signals";
import type { ILiveChatState, IChatMessage, ChatConnectionStatus } from "./types";

/**
 * Default live chat state implementation using Signal.State.
 * Properties are reactive - components using SignalWatcher auto-update.
 */
export class LiveChatState implements ILiveChatState {
  readonly messages = new Signal.State<IChatMessage[]>([]);
  readonly connectionStatus = new Signal.State<ChatConnectionStatus>("idle");
  readonly currentEventId = new Signal.State<string | null>(null);
  readonly errorMessage = new Signal.State<string>("");
  readonly isSending = new Signal.State<boolean>(false);
  readonly unreadCount = new Signal.State<number>(0);
  readonly isViewing = new Signal.State<boolean>(false);
}
